<app-loading *ngIf="contentReady"></app-loading>

<div class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                                  <span class="bb-eyebrow">{{ 'Pet Management' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'Pet Management' | transloco }}</h2>
        <p class="bb-page-subtitle">
          {{ clientId ? ('manage client pets' | transloco) : ('manage pets' | transloco) }}
        </p>
      </div>

      <div class="bb-header-actions">
        <button type="button" class="bb-btn bb-btn-primary" routerLink="/createpet">
          {{ 'إنشاء حيوان' | transloco }}
        </button>
      </div>
    </div>

    <!-- Pet Form -->
    <div class="bb-card bb-p-20 bb-mb-16" *ngIf="clientId">
      <form class="bb-grid bb-gap-16" [formGroup]="petForm" (ngSubmit)="savePet()">

        <div class="bb-text-stack">
          <h3 class="bb-m-0 bb-text-navy bb-font-bold">
            {{ editMode ? ('Edit pet' | transloco) : ('Add pet' | transloco) }}
          </h3>

          <p class="bb-m-0 bb-text-muted bb-font-semibold">
            {{ 'fill pet data' | transloco }}
          </p>
        </div>

        <div class="bb-filter-grid">
          <div class="bb-field">
            <label class="bb-label" for="pet_type">
              {{ "pet" | transloco }}
            </label>

            <div class="bb-select-wrap">
              <select
                class="bb-select"
                id="pet_type"
                formControlName="pet_type"
                [ngClass]="{
                  'is-invalid': petForm.get('pet_type')?.touched && petForm.get('pet_type')?.invalid,
                  'is-valid': petForm.get('pet_type')?.touched && petForm.get('pet_type')?.valid
                }"
              >
                <option value="">-- {{ 'choose' | transloco }} --</option>
                <option value="0">{{ "cats" | transloco }}</option>
                <option value="1">{{ "dogs" | transloco }}</option>
                <option value="2">{{ "birds" | transloco }}</option>
                <option value="4">{{ "cats&dogs" | transloco }}</option>
                <option value="3">{{ "other" | transloco }}</option>
              </select>
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label" for="name">
              {{ "Pet name" | transloco }}
            </label>

            <input
              class="bb-input"
              id="name"
              type="text"
              formControlName="name"
              placeholder="{{ 'Pet name' | transloco }}"
              [ngClass]="{
                'is-invalid': petForm.get('name')?.touched && petForm.get('name')?.invalid,
                'is-valid': petForm.get('name')?.touched && petForm.get('name')?.valid
              }"
            />
          </div>
        </div>

        <div class="bb-filter-grid">
          <div class="bb-field">
            <label class="bb-label" for="breed">
              {{ 'Breed' | transloco }}
            </label>

            <input
              class="bb-input"
              id="breed"
              type="text"
              formControlName="breed"
              placeholder="{{ 'Breed' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="color">
              {{ 'Color' | transloco }}
            </label>

            <input
              class="bb-input"
              id="color"
              type="text"
              formControlName="color"
              placeholder="{{ 'Color' | transloco }}"
            />
          </div>
        </div>

        <div class="bb-filter-grid">
          <div class="bb-field">
            <label class="bb-label" for="special_markings">
              {{ 'Special Markings' | transloco }}
            </label>

            <input
              class="bb-input"
              id="special_markings"
              type="text"
              formControlName="special_markings"
              placeholder="{{ 'Special Markings' | transloco }}"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="date_of_birth">
              {{ 'Date of Birth' | transloco }}
            </label>

            <input
              class="bb-input"
              id="date_of_birth"
              type="date"
              formControlName="date_of_birth"
            />
          </div>
        </div>

        <div class="bb-filter-grid">
          <div class="bb-field">
            <label class="bb-label" for="gender">
              {{ 'Gender' | transloco }}
            </label>

            <div class="bb-select-wrap">
              <select class="bb-select" id="gender" formControlName="gender">
                <option value="male">{{ 'Male' | transloco }}</option>
                <option value="female">{{ 'Female' | transloco }}</option>
              </select>
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label">
              {{ 'Spayed / Neutered' | transloco }}
            </label>

            <label class="bb-check-line">
              <input
                class="bb-checkbox"
                type="checkbox"
                id="spayed_neutered"
                formControlName="spayed_neutered"
              />

              <span>{{ "Yes" | transloco }} / {{ "no" | transloco }}</span>
            </label>
          </div>
        </div>

        <div class="bb-flex bb-items-center bb-gap-12 bb-wrap">
          <button class="bb-btn bb-btn-primary" type="submit" [disabled]="petForm.invalid">
            {{ editMode ? ('Update' | transloco) : ('Submit' | transloco) }}
          </button>

          <button class="bb-btn bb-btn-secondary" type="button" (click)="resetForm()">
            {{ 'Reset' | transloco }}
          </button>
        </div>

      </form>
    </div>

    <!-- Search Card -->
    <div class="bb-filter-card">
      <div class="search-row">
        <div class="search-box">
          <input
            type="text"
            class="bb-input"
            [(ngModel)]="searchKey"
            placeholder="{{ 'Pet name' | transloco }}"
            (keydown.enter)="onEnterPressed()"
          />

          <button class="bb-btn bb-btn-primary" type="button" (click)="search()">
            {{ "Search" | transloco }}
          </button>

          <button
            *ngIf="searched"
            class="bb-btn bb-btn-secondary"
            type="button"
            (click)="clearSearch()"
          >
            {{ "all data" | transloco }}
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="bb-table-card" *ngIf="!noData">
      <div class="bb-table-scroll">
        <table
          mat-table
          id="stocktable"
          [dataSource]="dataSource"
          class="bb-table mat-elevation-z0"
        >

          <!-- Pet Type -->
          <ng-container matColumnDef="pet_type">
            <th mat-header-cell *matHeaderCellDef>
              {{ "pet" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <span class="bb-badge pet-type-badge" [ngClass]="getPetTypeClass(element.pet_type)">
                {{ getPetTypeLabel(element.pet_type) }}
              </span>
            </td>
          </ng-container>

          <!-- Name -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Pet name" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div class="bb-text-stack">
                <strong class="bb-product-title">{{ element.name || '—' }}</strong>
              </div>
            </td>
          </ng-container>

          <!-- Breed -->
          <ng-container matColumnDef="breed">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Breed" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <span class="bb-text-muted bb-font-semibold">
                {{ element.breed || '—' }}
              </span>
            </td>
          </ng-container>

          <!-- Color -->
          <ng-container matColumnDef="color">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Color" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <span class="bb-text-muted bb-font-semibold">
                {{ element.color || '—' }}
              </span>
            </td>
          </ng-container>

          <!-- Gender -->
          <ng-container matColumnDef="gender">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Gender" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <span class="bb-badge gender-badge" [ngClass]="element.gender">
                {{ element.gender === 'female' ? ('Female' | transloco) : ('Male' | transloco) }}
              </span>
            </td>
          </ng-container>

          <!-- Date of Birth -->
          <ng-container matColumnDef="date_of_birth">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Date of Birth" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <span class="bb-text-muted bb-font-semibold">
                {{ element.date_of_birth ? (element.date_of_birth | date: 'yyyy-MM-dd') : '—' }}
              </span>
            </td>
          </ng-container>

          <!-- Spayed / Neutered -->
          <ng-container matColumnDef="spayed_neutered">
            <th mat-header-cell *matHeaderCellDef>
              {{ "Spayed / Neutered" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <span
                class="bb-badge status-badge"
                [class.success]="isYes(element.spayed_neutered)"
                [class.danger]="!isYes(element.spayed_neutered)"
              >
                {{ isYes(element.spayed_neutered) ? '✓' : '✗' }}
              </span>
            </td>
          </ng-container>

          <!-- Client -->
          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef>
              {{ "client" | transloco }}
            </th>

            <td mat-cell *matCellDef="let element">
              <div *ngIf="element.client" class="bb-text-stack">
                <strong class="bb-text-navy">{{ element.client.client_name || '—' }}</strong>

                <a [href]="'tel:' + element.client.phone_number" class="bb-link-action bb-inline-flex">
                  {{ element.client.phone_number }}
                </a>
              </div>

              <span *ngIf="!element.client" class="bb-text-muted">—</span>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="bb-actions-th"></th>

            <td mat-cell *matCellDef="let element" class="bb-actions-td">
              @if (isSubAdmin) {
                <button
                  type="button"
                  class="bb-icon-btn action-btn cart"
                  (click)="vaccinations(element.id)"
                  [title]="'vaccinations' | transloco"
                >
                  <i class="fa-solid fa-syringe"></i>
                </button>
              } @else {
              <div class="dropdown bb-action-dropdown">
                <button
                  class="bb-icon-btn action-btn menu"
                  type="button"
                  data-bs-toggle="dropdown"
                  data-bs-boundary="viewport"
                  aria-expanded="false"
                  title="{{ 'Actions' | transloco }}"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="19" r="2" />
                  </svg>
                </button>

                <ul class="dropdown-menu dropdown-menu-end bb-dropdown-menu">

                  <li>
                    <button
                      class="dropdown-item bb-dropdown-item"
                      type="button"
                      (click)="editPet(element)"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>

                      {{ "Edit" | transloco }}
                    </button>
                  </li>

                  <li>
                    <button
                      class="dropdown-item bb-dropdown-item"
                      type="button"
                      (click)="vaccinations(element.id)"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <path d="M12 2v6M12 18v4M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M2 12h6M18 12h4M4.93 19.07l4.24-4.24M14.83 9.17l4.24-4.24" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>

                      {{ "vaccinations" | transloco }}
                    </button>
                  </li>

                  <li>
                    <hr class="dropdown-divider">
                  </li>

                  <li>
                    <button
                      class="dropdown-item bb-dropdown-item text-danger"
                      type="button"
                      (click)="deletePet(element.id)"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                      </svg>

                      {{ "Delete" | transloco }}
                    </button>
                  </li>

                </ul>
              </div>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="mat-row-custom"
            [class.highlight-upcoming]="row?.hasUpcomingVaccination"
          ></tr>

        </table>
      </div>

      <mat-paginator
        *ngIf="!noData && allData.length > 0"
        class="bb-paginator"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>

    <div class="bb-empty-state" *ngIf="noData">
      <app-nodata></app-nodata>
    </div>

  </div>
</div>
